import { WashingType } from "../../types/washingTypes.types"

export const renderWashType = (option: WashingType) => {
  return `
    ${option.name} | R$ ${option.price.toFixed(2)}
  `
}